'use client'

import * as React from 'react'
import { cn } from '@/lib/utils'

interface MRRCardProps extends React.ComponentProps<'div'> {
  sessionCode?: string
  chapterLabel?: string
  variant?: 'default' | 'translucent'
  onClick?: () => void
}

export function MRRCard({
  sessionCode,
  chapterLabel,
  variant = 'default',
  onClick,
  className,
  children,
  ...props
}: MRRCardProps) {
  const isClickable = Boolean(onClick)

  const baseClasses = 'relative rounded-2xl border border-slate-faint shadow-[0_1px_0_rgba(26,26,26,0.04),0_8px_24px_-12px_rgba(26,26,26,0.08)] overflow-hidden'
  const variantClasses = variant === 'translucent'
    ? 'bg-white/50'
    : 'bg-paper-card'

  return (
    <div
      className={cn(
        baseClasses,
        variantClasses,
        'p-7 sm:p-9 lg:p-12',
        isClickable && 'active:translate-y-[1px] transition-transform duration-100 cursor-pointer',
        className
      )}
      onClick={onClick}
      role={isClickable ? 'button' : undefined}
      tabIndex={isClickable ? 0 : undefined}
      {...props}
    >
      {(sessionCode || chapterLabel) && (
        <div className="flex items-center gap-3 mb-8">
          {sessionCode && (
            <span className="text-kicker text-copper">{sessionCode}</span>
          )}
          {sessionCode && chapterLabel && (
            <span className="text-kicker text-ink-faint">·</span>
          )}
          {chapterLabel && (
            <span className="text-[12px] font-semibold uppercase tracking-[0.2em] text-ink-faint">{chapterLabel}</span>
          )}
        </div>
      )}
      {children}
    </div>
  )
}
